import { AbstractModel } from '@patsnap/tahiti-core';
import { CurrentSelectedRetrievalTypeModel } from '../current-selected-retrieval-type-model';
import type { CurrentSelectedRetrievalTypeState } from '../../types';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

/**
 * 创建初始的选中检索类型状态
 * @description 默认选中专利检索
 */
function createInitialSelectedRetrievalTypeState(): CurrentSelectedRetrievalTypeState {
    return {
        selectedType: 'patent',
    };
}

/**
 * 当前选中的检索类型模型实现
 */
@injectable()
export class CurrentSelectedRetrievalTypeModelImpl extends AbstractModel<CurrentSelectedRetrievalTypeState> implements CurrentSelectedRetrievalTypeModel {
    protected _modelData: CurrentSelectedRetrievalTypeState = createInitialSelectedRetrievalTypeState();

    clone(data: CurrentSelectedRetrievalTypeState): CurrentSelectedRetrievalTypeState {
        return { ...data };
    }

    dispose(): void {
        this.update(() => createInitialSelectedRetrievalTypeState());
    }
}
